// extracted by mini-css-extract-plugin
module.exports = {"lds-dual-ring":"spinner_lds-dual-ring__35ZgD"};